// Renders stored wishlist handles as real _product-card markup, via the shared
// theme.renderProductCards helper (see theme-base.js). Prices and stock are
// therefore always live, and handles whose product no longer exists are pruned.
(function (t) {
  // opts.loader is passed straight through to renderProductCards; the wishlist page
  // keeps card skeletons.
  t.renderWishlistInto = function (container, emptyEl, opts) {
    if (!container) return Promise.resolve();
    const handles = t.getWishlist ? t.getWishlist() : [];

    const toggleEmpty = (isEmpty) => {
      if (emptyEl) emptyEl.hidden = !isEmpty;
      container.hidden = isEmpty;
    };

    if (!handles.length) { container.innerHTML = ""; toggleEmpty(true); return Promise.resolve(); }

    toggleEmpty(false);
    const items = handles.map((handle) => ({ url: t.productUrl(handle), id: handle }));

    return t.renderProductCards(container, items, opts).then(({ rendered, gone }) => {
      gone.forEach((handle) => { if (t.removeFromWishlist) t.removeFromWishlist(handle); });
      if (!rendered) toggleEmpty(true);
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    // Wishlist page: render immediately and keep it in sync. (The wishlist drawer
    // was removed — the header heart navigates here instead.)
    const page = document.querySelector("[data-wishlist-page]");
    if (page) {
      const pageEmpty = document.querySelector("[data-wishlist-page-empty]");
      t.renderWishlistInto(page, pageEmpty);
      document.addEventListener("wishlist:change", function () { t.renderWishlistInto(page, pageEmpty); });
    }
  });
})((window.theme = window.theme || {}));
